import { useCallback } from 'react';

import {
  type AutomationRunSessionOpenedLocation,
  useTrackAgentThreadOpened,
  useTrackAutomationRunSessionOpened,
  type WorkspaceAgentThreadReopenedStatus,
} from '@air/analytics';

import { toAutomationsAnalyticsRunStatus } from '~/components/Automations/utils/automationsAnalyticsParams';
import { type AutomationRun } from '~/hooks/queries/automations/usePrivateAutomationRunsList';

export type TrackPrivateAutomationRunSessionOpenParams = {
  automationId: string;
  location: AutomationRunSessionOpenedLocation;
  run: Pick<AutomationRun, 'status'>;
  sessionId: string;
  threadReopenedStatus: WorkspaceAgentThreadReopenedStatus;
};

export const usePrivateAutomationRunSessionOpenAnalytics = () => {
  const { trackAutomationRunSessionOpened } = useTrackAutomationRunSessionOpened();
  const { trackAgentThreadOpened } = useTrackAgentThreadOpened();

  const trackAutomationRunSessionOpen = useCallback(
    ({ automationId, location, run, sessionId, threadReopenedStatus }: TrackPrivateAutomationRunSessionOpenParams) => {
      trackAutomationRunSessionOpened({
        automation_id: automationId,
        location,
        run_status: toAutomationsAnalyticsRunStatus(run.status),
      });
      trackAgentThreadOpened({
        is_first_run_walkthrough: false,
        reopened_from: 'automation_run',
        session_id: sessionId,
        status: threadReopenedStatus,
        type: 'existing',
      });
    },
    [trackAgentThreadOpened, trackAutomationRunSessionOpened],
  );

  return { trackAutomationRunSessionOpen };
};
